import apiUrlAddresses from 'config/constants/api-urls-addresses'
import { Http } from 'lib'
import { Dispatch } from 'react'
import { SITE } from 'config/constants/env'
import { downloadingPDF, toggleSocialMediaButtonDialogOpen, ToolbarAction } from './store/Actions'
import { ToolbarState } from './store/State'
export default class ToolbarService {
  static getPublicProfileUrl(profileId: string): string {
    return `${SITE.WEBAPP_URL}/profile/${profileId}`
  }

  static copyToClipboard(profileId: string, copy: (_: string) => boolean, onCopyToClipboard: () => void) {
    return () => {
      const result = copy(ToolbarService.getPublicProfileUrl(profileId))

      if (result) {
        onCopyToClipboard()
      }
    }
  }

  static getSocialMediaButtonMarkup(profileId: string, firstName: string, lastName: string) {
    return () => {
      return `
        <a href="${ToolbarService.getPublicProfileUrl(profileId)}">
          <img src="${SITE.WEBAPP_URL}/icons/pointr-mini.png" alt="${firstName} ${lastName} - Pointr digital profile" />
        </a>
      `
    }
  }

  static downloadPDF(
    userId: string,
    dispatch: Dispatch<ToolbarAction>,
    onSuccess?: (PDF: string) => void,
    onError?: (error: string) => void
  ) {
    return async () => {
      dispatch(downloadingPDF(true))

      const [PDF, , error] = await Http.get<string>(apiUrlAddresses.billboard.pdf(userId))

      dispatch(downloadingPDF(false))

      if (error) {
        onError(error)
      } else {
        onSuccess(PDF)
      }
    }
  }

  static getPointrSocialMediaButton(state: ToolbarState, dispatch: Dispatch<ToolbarAction>) {
    return () => {
      dispatch(toggleSocialMediaButtonDialogOpen(!state.isSocialMediaButtonDialogOpen))
    }
  }

  static onCopySocialButtonMarkup(copy: (_: string) => boolean) {
    return (markup: string) => {
      return copy(markup)
    }
  }
}
